import request from '@meitu/saas-editor-ui/es/request';
import { getWebApiHostname } from '@/utils/request';
import { IWxOfficialResponse } from './index.d';

/**
 * 获取微信公众号二维码
 */
export const getWxOfficialQrCode = async function (name: string) {
    return await request<IWxOfficialResponse>(`${getWebApiHostname()}/common/get_wechat_official_account_qr_code`, {
        method: 'GET',
        params: {
            name,
        },
    });
};
